
import React from 'react';

export interface EditorControlsProps {
  onSave?: () => void;
}

export const EditorControls: React.FC<EditorControlsProps> = () => {
  return (
    <div className="absolute top-4 right-4 z-[1100]">
      {/* This component is now empty as we removed the help button */}
    </div>
  );
};
